// src/pages/HomePage.styles.js

import styled from 'styled-components'; // Needed for styled components
import BACKGROUND_IMAGE from '../assets/background.jpg'; // Import the background image here
import rocketIcon from '../assets/rocket-icon.png'; // Import rocket icon if StyledMissionList/Item is used here
import '../fonts/font.css'




// --- THEME COLORS ---
export const colors = {
    textColor: '#ffffff',
    accentColor: '#19abf0',
    cardBorder: 'rgba(255, 255, 255, 0.5)',
    accentColorDarker: '#006993'
};

// --- Global Page Layout Styles (Plain JS Objects) ---
export const pageContainerStyles = {
    //backgroundImage: `url(${BACKGROUND_IMAGE})`,
    backgroundSize: 'auto', // Tiled pattern
    backgroundPosition: 'center top',
    backgroundRepeat: 'repeat',
    backgroundColor: 'transparent',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingTop: '2rem', // Space for fixed Navbar
    color: colors.textColor,
    boxSizing: 'border-box',
    width: '100vw',
    overflowX: 'hidden',
    minHeight: 'calc(var(--app-height, 100vh) + 50vh)',

    fontFamily: 'roboto_regular',
};


